/** 套餐类型 */
export enum GrantType {
  /** 个人套餐 */
  Personal = 1,
  /** 企业套餐 */
  Enterprise = 2,
  /** 个人+企业都可购买 */
  PersonalAndEnterprise = 3,
}

/** 套餐订单类型 */
export enum GrantOrderType {
  /** 套餐购买 */
  PackageBuy = 1,
  /** 充值 */
  Recharge = 2,
  /** 加油包购买 */
  PackBuy = 3,
}

// 是否可购买改套餐
export enum GrantAvailability {
  // 可购买
  Purchasable = 1,
  // 已有订阅套餐，不可购买
  SubscriptionDisabled = 2,
  // 已有充值套餐，不可购买
  TopUpDisabled = 3,
  // 个人套餐，企业用户不可购买
  PersonalOnly = 4,
  // 企业套餐，个人用户不可购买
  EnterpriseOnly = 5,
  // 企业准入未审批，不可购买
  EnterpriseApprovalRequired = 6,
  // 其他不可购买的情况
  NotPurchasable = 7,
}

export enum GrantLabel {
  /** 默认 */
  Default = 0,
  /** 热门套餐 */
  Hot = 1,
  /** 推荐套餐 */
  Recommend = 2,
}

/** 套餐订单状态 */
export enum GrantOrderStatus {
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
  Canceled = 'canceled',
  Confirming = 'confirming',
}

/** 可玩MTG是否计费 */
export enum MtgCharge {
  /** 不计费 */
  NoCharge = 2,
  /** 计费 */
  Charge = 1,
  /** 该套餐没有这项计费 */
  None = 0,
}

/** 币种信息 */
export enum Currency {
  /** 美元 */
  USD = 1,
  /** 人民币 */
  CNY = 2,
}

export enum PlanUsageType {
  DownloadPush = 'download_push',
  Storage = 'storage',
  VideoCredits = 'video_credits',
  Online = 'online',
}

export enum TransactionStatus {
  WaitPay = 'wait_pay',
  SuccessPay = 'success_pay',
  FailedPay = 'failed_pay',
  SuccessConfirm = 'success_confirm',
}
